module.exports = __webpack_public_path__ + "img/champ.f5004972.png";